import { createAsyncThunk } from '@reduxjs/toolkit';
// actions
import * as actions from 'slices/class';
// api
import * as classAPI from 'api/class';

/**
 * @dispatch 클래스 데이터 호출
 * @param {object} props
 * @param {string} props.classId
 */
export const getClass = createAsyncThunk('class/getClass', async ({ classId }, { dispatch }) => {
  const res = await classAPI.getClass({ classId });

  /** 클래스 정보 */
  dispatch(
    actions.updateClassInfo({
      class_have_status: res.class_have_status,
      payment_yn: res.payment_yn,
    }),
  );

  /* 선택된 클래스 정보 */
  dispatch(actions.updateSelectedClass(res.class));

  return Promise.resolve(true);
});
